import Image from 'next/image';
import Link from 'next/link';
import { DAVINCI_CDN } from '@/costants/defaultValues';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export const ServiceCard: React.FC<{ link: string | undefined; service: string; location?: string; description?: string }> = ({
  link,
  service,
  location,
  description,
}) => {
  const urlParams = new URLSearchParams();

  if (location) {
    urlParams.set('location', location.toLowerCase());
  }

  urlParams.set('service', service);

  return (
    <li className="group w-full flex-grow">
      <Link
        href={link ? link : `/cerca?${urlParams.toString()}`}
        className="shadow-1 flex flex-row items-center rounded-xl border border-white bg-white px-5 py-3 transition-colors group-hover:border-elty-green group-focus:border-elty-green"
      >
        <div className="flex flex-grow flex-col gap-2">
          <div className="flex flex-row items-center gap-3">
            <Image
              src={`${DAVINCI_CDN}/inclinic/icons/medical-services.png`}
              alt="icona servizio medico"
              width={24}
              height={24}
              aria-hidden
            />
            <span aria-label="prestazione">{service}</span>
          </div>
          {location && (
            <div className="text-text-body flex flex-row items-center gap-3 text-sm text-neutral-lighter">
              <Image src={`${DAVINCI_CDN}/inclinic/icons/pin.png`} width={24} height={24} alt="Right arrow" />
              <span aria-label="posizione">{location}</span>
            </div>
          )}
          {description && (
            <div className="flex flex-row items-center gap-3 py-3 pr-3 text-sm text-neutral-lighter">
              <span aria-label="posizione">{description}</span>
            </div>
          )}
        </div>
        <ChevronRightIcon
          className="shrink-0 translate-x-0 transition-transform group-hover:translate-x-2"
          title="icona freccia destra"
          width={20}
          height={20}
          color="#07142F"
          aria-hidden
        />
      </Link>
    </li>
  );
};
